import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = [
  "#",
  "مباشر",
  "کاربر",
  "کدملی کاربر",
  "درآمد",
  "سرویس",
  "رشته",
  "گرایش",
  "زمان"
];

export function AgentIncomeReportGrid({
                                        agentIncomeReport,
                                      }) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "مباشر": "agent_name",
    "کاربر": "person_name",
    "کدملی کاربر": "person_national_code",
    "درآمد": "value",
    "سرویس": "type",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "زمان": "created_at",
  }

  const headSortable = {
    "#": "",
    "مباشر": true,
    "کاربر": true,
    "کدملی کاربر": true,
    "درآمد": true,
    "سرویس": true,
    "رشته": true,
    "گرایش": true,
    "زمان": true,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {agentIncomeReport.map(
          ({
             id,
             agent_name,
             agent_phone,
             person_name,
             person_national_code,
             value,
             type,
             field_title,
             branch_title,
             created_at,
           }, index) => {
            const isLast = index === agentIncomeReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {person_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(person_national_code)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {type}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[0])}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[1])}
                    </Typography>

                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}